import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next'; // 1. Import hook

// Assume you have placed the founder's photo at this path
import founderImage from '../assets/images/lalith.jpg';

const FounderStory = () => {
  const { t } = useTranslation(); // 2. Initialize translation function

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
      }}
    >
      <Container maxWidth="lg">
        <Card sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, boxShadow: 'none', backgroundColor: 'transparent' }}>
          <Grid container spacing={{ xs: 4, md: 8 }} alignItems="center">
            
            {/* Left Column: The Image */}
            <Grid item size={{ xs: 12, md: 5 }}> {/* Corrected grid props */}
              <Box
                component="img"
                src={founderImage}
                alt={t('founder_image_alt')} // 3. Use translation
                sx={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '8px',
                  boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
                  objectFit: 'cover',
                  maxHeight: { xs: 400, md: 600 },
                }}
              />
            </Grid>
            
            {/* Right Column: The Story */}
            <Grid item size={{ xs: 12, md: 7 }}> {/* Corrected grid props */}
              <Box>
                 <Typography
                    variant="h3"
                    component="h2"
                    sx={{
                      fontWeight: 500,
                      mb: 3,
                      lineHeight: 1.3,
                      fontFamily: 'serif',
                      color:'#005F69',
                      textAlign: 'center'
                    }}
                  >
                  {t('founder_headline')}
                </Typography>

                <Typography
                  variant="h6"
                  component="p"
                  sx={{
                    fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
                    fontWeight: 400,
                    color: 'text.secondary',
                    mb: 4,
                  }}
                >
                  {t('founder_title')}
                </Typography>

                <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                  {t('founder_para1')}
                </Typography>
                
                <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                  {t('founder_para2')}
                </Typography>

                <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
                  {t('founder_para3')}
                </Typography>

                <Typography
                  component="blockquote"
                  sx={{
                    fontFamily: '"Cormorant Garamond", "Georgia", serif',
                    fontStyle: 'italic',
                    fontSize: '1.5rem',
                    color: 'text.primary',
                    mt: 4,
                    pl: 2,
                    borderLeft: 3,
                    borderColor: 'primary.main',
                  }}
                >
                  “{t('founder_quote')}”
                </Typography>
              </Box>
            </Grid>

          </Grid>
        </Card>
      </Container>
    </Box>
  );
};
//Dummy Card Component in case not already defined.
const Card = (props) => <Box {...props} />;

export default FounderStory;